import request from '@/utils/request3'

export function getPage(data) {
  return request({
    url: '/charge-table/getpage',
    method: 'post',
    data
  })
}

export function saveData(data) {
  return request({
    url: '/charge-table/saveData',
    method: 'post',
    data
  })
}

export function editData(data) {
  return request({
    url: '/charge-table/modifyData',
    method: 'post',
    data
  })
}


export function dropData(data) {
  return request({
    url: '/charge-table/dropData',
    method: 'post',
    params: data
  })
}